import { TableRow, TableCell, Typography, Button } from '@mui/material';

// ----------------------------------------------------------------------

export default function AccountSelectionTableRow({ row, selectContentHandler }) {
  const { SocialManagerAccountTypeID, SocialManagerAccountTypeName, RowNum } = row;

  return (
    <TableRow hover>
      <TableCell align="center">
        <Typography variant="body1">{RowNum}</Typography>
      </TableCell>

      <TableCell className="fixed-table-cell" align="center">
        <Typography variant="body1">{SocialManagerAccountTypeName}</Typography>
      </TableCell>

      <TableCell align="center">
        <Typography variant="body1">{SocialManagerAccountTypeID}</Typography>
      </TableCell>

      <TableCell align="right">
        <Button color="warning" variant="contained" onClick={() => selectContentHandler(row)}>
          انتخاب
        </Button>
      </TableCell>
    </TableRow>
  );
}
